import React from 'react';
import { View, StyleSheet } from 'react-native';
import Logo from 'design-system/Logo';
import Text from 'design-system/Text';
import Amount from 'design-system/Amount';
import { rem, Spacer } from 'design-system';
import StatusIcon from 'design-system/StatusIcon';
const ClaimRewardsRow = ({ item, isPending, }) => {
    const { title, partner: { iconUrl }, totalAmount, currency, } = item;
    if (!totalAmount) {
        return null;
    }
    return (<View style={styles.container}>
      <View style={styles.partner}>
        <Logo R44 uri={iconUrl} resizeMode="contain"/>
        <Spacer w={16}/>
        <View style={styles.flex}>
          <Text Text-16 numberOfLines={1}>
            {title}
          </Text>
          {isPending ? (<View style={styles.infoRow}>
              <StatusIcon state="in-progress" width={16} height={16}/>
              <Spacer w={8}/>
              <Text TextThin-14 StatusInformational>
                Pending
              </Text>
            </View>) : null}
        </View>
        <Spacer w={16}/>
      </View>
      <Amount Numbers-16 value={{ value: totalAmount, currency }}/>
    </View>);
};
const styles = StyleSheet.create({
    container: {
        padding: rem(16),
        alignItems: 'center',
        flexDirection: 'row',
    },
    partner: {
        flexDirection: 'row',
        alignItems: 'center',
        flex: 1,
    },
    flex: {
        flex: 1,
        justifyContent: 'center',
    },
    infoRow: {
        alignItems: 'center',
        flexDirection: 'row',
    },
});
export default React.memo(ClaimRewardsRow);
